import { render, staticRenderFns } from "./LikeAction.vue?vue&type=template&id=55f768d3&"
import script from "./LikeAction.vue?vue&type=script&lang=js&"
export * from "./LikeAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports